// Action: updateCarValueAndExcess.js
// API utility for updating car value and excess

import showToaster from '../helpers/toasterMessages/showToaster';

export const updateCarValueAndExcess = async (listId, carRangeId) => {
  const response = await fetch('/graphql', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query: `
        mutation UpdateCarValueAndExcess($listId: Int!, $carRangeId: Int!) {
          updateCarValueAndExcess(listId: $listId, carRangeId: $carRangeId) {
            status
            errorMessage
            message
            listing
          }
        }
      `,
      variables: { listId, carRangeId }
    })
  });

  const result = await response.json();
  if (result.data?.updateCarValueAndExcess?.status === 200) {
    showToaster({ messageId: 'carValueExcessSuccess', toasterType: 'success' });
    return result.data.updateCarValueAndExcess;
  } else {
    showToaster({ messageId: 'carValueExcessFailed', toasterType: 'error' });
    return null;
  }
};
